import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Auth0Provider } from './components/auth/Auth0Provider'
import { ConvexProviderWithAuth0 } from 'convex/react-auth0'
import { ConvexReactClient } from 'convex/react'
import { ToastProvider } from './components/common/Toast'
import { LanguageSync } from './components/LanguageSync'
import { Landing } from './pages/Landing'
import { Login } from './pages/Login'
import { OnboardingFlow } from './pages/OnboardingFlow'
import { VoiceOnboardingFlow } from './pages/VoiceOnboardingFlow'
import { OAuthCallback } from './pages/OAuthCallback'
import { Dashboard } from './pages/Dashboard'
import { LovedOneDetail } from './pages/LovedOneDetail'
import { ActivityHistory } from './pages/ActivityHistory'
import { MedicationFeature } from './pages/MedicationFeature'
import { ShoppingFeature } from './pages/ShoppingFeature'
import { Settings } from './pages/Settings'
import { Privacy } from './pages/Privacy'
import { Terms } from './pages/Terms'
import { ProtectedRoute } from './components/auth/ProtectedRoute'

// Initialize Convex client
const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL || '')

function App() {
  return (
    <Auth0Provider>
      <ConvexProviderWithAuth0 client={convex}>
        <LanguageSync />
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/onboarding" element={<OnboardingFlow />} />
              <Route path="/voice-onboarding" element={<VoiceOnboardingFlow />} />
              <Route path="/auth/callback" element={<OAuthCallback />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/:lovedOneId"
                element={
                  <ProtectedRoute>
                    <LovedOneDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/:lovedOneId/activity"
                element={
                  <ProtectedRoute>
                    <ActivityHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/:lovedOneId/medications"
                element={
                  <ProtectedRoute>
                    <MedicationFeature />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/:lovedOneId/shopping"
                element={
                  <ProtectedRoute>
                    <ShoppingFeature />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </ConvexProviderWithAuth0>
    </Auth0Provider>
  )
}

export default App
